"use client"

import { extractBlockProperties } from "@/utils/simplifyData"
import styled from "@emotion/styled"
import { useState } from "react"
import BlockWrapper from "../../common/BlockWrapper"
import PeopleList from "./PeopleList"
import SelectPeoplePopup, { Person } from "./SelectPeoplePopup"
const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PeopleContainerBlock = ({ data }: { data: any }) => {
  const { itemsList } = data
  const peopleData = extractBlockProperties(itemsList.blocks)
  const [selectedPerson, setSelectedPerson] = useState<Person | null>(null)
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  const handlePersonClick = (person: Person) => {
    setSelectedPerson(person)
    setIsPopupOpen(true)
  }

  const handleClosePopup = () => {
    setIsPopupOpen(false)
  }

  return (
    <BlockWrapper
      style={{
        alignItems: "center",
      }}
    >
      <StyledContainer>
        <PeopleList people={peopleData} onPersonClick={handlePersonClick} />
        {selectedPerson && (
          <SelectPeoplePopup
            person={selectedPerson}
            open={isPopupOpen}
            onClose={handleClosePopup}
          />
        )}
      </StyledContainer>
    </BlockWrapper>
  )
}

export default PeopleContainerBlock
